import { render, staticRenderFns } from "./CampoYesNo.vue?vue&type=template&id=525df9fb&"
import script from "./CampoYesNo.vue?vue&type=script&lang=js&"
export * from "./CampoYesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports